<div class="modal-overlay" (click)="fechar()">
  <div class="modal-container" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2>Adicionar empresas ao módulo</h2>
      <button class="btn-fechar" (click)="fechar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-filtros">
      <mat-form-field appearance="outline" class="campo-filtro">
        <mat-label>Filtro</mat-label>
        <mat-select [(ngModel)]="campoBusca" (ngModelChange)="aplicarFiltro()">
          <mat-option value="nomeFantasia">Nome</mat-option>
          <mat-option value="cnpj">CNPJ</mat-option>
          <mat-option value="estado">Estado</mat-option>
          <mat-option value="cidade">Cidade</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="campo-busca">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Buscar"
          [(ngModel)]="termoBusca"
          (ngModelChange)="aplicarFiltro()"
        />
      </mat-form-field>

      <button class="btn-icone" [disabled]="selecionadas.length === 0" (click)="limparSelecao()">
        <img src="../../../assets/svg/icons/delete_trash.svg" alt="Excluir" style="width: 20px; height: 20px;" />
      </button>
    </div>

    <div class="tabela-wrapper">

    <div class="modal-loading" *ngIf="isLoading">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <table mat-table [dataSource]="dataSource" matSort #sort="matSort" *ngIf="!isLoading" class="tabela-modal">

      <ng-container matColumnDef="selecionar">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="todasSelecionadas"
            [indeterminate]="algunsSelecionados"
            (change)="toggleTodas($event.checked)"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let empresa">
          <mat-checkbox
            [checked]="estaSelecionada(empresa)"
            (change)="toggleEmpresa(empresa, $event.checked)"
            (click)="$event.stopPropagation()"
          ></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="nomeFantasia">Nome</th>
        <td mat-cell *matCellDef="let empresa">
          <span class="empresa-nome">{{ empresa.nomeFantasia }}</span>
          <span class="empresa-razao">{{ empresa.razaoSocial }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="cnpj">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="cnpj">CNPJ</th>
        <td mat-cell *matCellDef="let empresa">{{ empresa.cnpj }}</td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="estado">Estado</th>
        <td mat-cell *matCellDef="let empresa">{{ empresa.estado }}</td>
      </ng-container>

      <ng-container matColumnDef="cidade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="cidade">Cidade</th>
        <td mat-cell *matCellDef="let empresa">{{ empresa.cidade }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunas"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: colunas"
        [class.selecionada]="estaSelecionada(row)"
        (click)="toggleEmpresa(row, !estaSelecionada(row))"
      ></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell sem-dados" [attr.colspan]="colunas.length">
          Nenhuma empresa encontrada.
        </td>
      </tr>
    </table>

    </div> <!-- /tabela-wrapper -->

    <div class="modal-footer">
      <button
        class="btn-cheio"
        [disabled]="selecionadas.length === 0 || isSaving"
        (click)="confirmar()"
      >
        {{ isSaving ? 'Adicionando...' : 'Adicionar empresas selecionadas' }}
      </button>
    </div>

  </div>
</div>